import React  from "react";
import { useRouter } from "next/router";

import Tabs from "@/components/Tabs/Tabs";
import SubsContent from "./SubsContent";
import Feeds from "./Feeds";
import Thoughts from "./Thoughts";
import SubsTopPanel from "./SubsTopPanel";

import { validateDate } from "@/shared/utils/subscriptions";
import { withLogin } from "@/hocs/withLogin";
import { makeOption } from "@/shared/utils/select";
import { URLS } from "@/shared/utils/url/url";

import styles from "./subscriptions.module.scss";

const KeyOptionTabSubscriptions = "subscriptions";

const tabs = [
  makeOption("feeds", "feeds", {
    className: styles["subs-tabs-title"],
  }),
  makeOption(KeyOptionTabSubscriptions, "subscriptions", {
    className: styles["subs-tabs-title"],
  }),
  makeOption("thoughts", "thoughts", {
    className: styles["subs-tabs-title"],
  }),
];

const Subscriptions = () => {
  const router = useRouter();
  const [tab = KeyOptionTabSubscriptions] = router.query.subscription;

  const onChangeTab = (key) => {
    router.push(`${URLS.subscription}/${key}`);
  };

  const onDateChange = (newDate) => {
    router.push(`${URLS.subscription}/${tab}/${validateDate(newDate)}`);
  };

  return (
    <>
      <SubsTopPanel onDateChange={onDateChange} />
      <Tabs
        className={styles["subs-tabs"]}
        activeTabClassName={styles["active-sub"]}

        tabs={tabs}
        value={tab}
        onChangeTab={onChangeTab}
      >
        <Feeds />
        <SubsContent />
        <Thoughts />
      </Tabs>
    </>
  );
};

export default withLogin(Subscriptions);
